module.exports = __webpack_public_path__ + "assets/img/us-chamber-of-commerce-foundation.d3183f45.png";